export class LoanWrapper {
  query?: string;
  seller?: boolean;
  queryMap?: {} = {};
}
